import { isTop3 } from 'fitbeat.gym-core';
import { ILeaderboardRanking } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import {
  Platform,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import MedalIcon from '../../assets/icons/medal-lo-fi.svg';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  ranking: ILeaderboardRanking;
  isMyRank: boolean;
}

export const rankColorMapping = {
  1: '#FFC83B',
  2: '#C4C4C4',
  3: '#F47F2B',
};

const iconWidthAndHeight = defaultScale(23);

const LeaderboardPositionIndicator: FunctionComponent<IProps> = (
  {
    ranking,
    isMyRank,
  },
) => {
  const defaultTextColor = Theme.WHITE;
  const textColor = isMyRank ? defaultTextColor : Theme.BLACK;

  if (isTop3(ranking.rank)) {
    const iconBoarderColor = isMyRank ? Theme.DARK_CHARCOAL : Theme.WHITE;
    return (
      <View style={styles.container}>
        <MedalIcon
          color={rankColorMapping[ranking.rank]}
          colorSecondary={iconBoarderColor}
          width={iconWidthAndHeight}
          height={iconWidthAndHeight}
        />
        <View style={styles.topThreeRankTextContainer}>
          <Text style={styles.rankText}>{ranking.rank}</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Text style={[styles.rankText, { color: textColor }]}>
        {ranking.rank}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: defaultScale(25),
    marginLeft: defaultScale(5),
    alignItems: 'center',
  },
  initialsText: {
    fontSize: defaultScale(10),
    fontWeight: '800',
  },
  rankText: {
    ...Theme.textStyle.smallBold,
    lineHeight: Theme.textStyle.smallBold.fontSize,
    textAlign: 'center',
    width: iconWidthAndHeight,
    marginTop: Platform.OS === 'web' ? defaultScale(-2) : 0,
  },
  topThreeRankTextContainer: {
    position: 'absolute',
    top: defaultScale(4),
    right: 0,
    left: defaultScale(1),
    justifyContent: 'center',
  },
});

export default LeaderboardPositionIndicator;
